export default __webpack_public_path__ + "static/media/slc.6f22471e.jpg";